module.exports = __webpack_public_path__ + "static/media/wifi.52b1d0c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/wifi.svg
// module id = 478
// module chunks = 0